// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadmore-wrap[data-v-11d077ee]{width:100%;display:flex;flex-direction:column}.loadmore-wrap .mu-appbar[data-v-11d077ee]{width:100%}.loadmore-content[data-v-11d077ee]{flex:1;overflow:auto;-webkit-overflow-scrolling:touch}.mu-paper.mu-paper-round.mu-elevation-1[data-v-11d077ee]{box-shadow:none}.container[data-v-11d077ee],.loadmore-content.container[data-v-11d077ee]{padding:0}", ""]);
// Exports
module.exports = exports;
